import React from "react";
import { Link } from "react-router-dom";

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-xl font-bold text-[#0F172A] mb-4 pb-2 border-b border-[#E2E8F0]">
      {title}
    </h2>
    <div className="text-[#475569] leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Confidentialite() {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      {/* Header */}
      <div className="bg-white border-b border-[#E2E8F0]">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <Link to="/" className="text-[#0596DE] hover:underline text-sm">
            ← Retour à l'accueil
          </Link>
          <h1 className="text-3xl font-bold text-[#0F172A] mt-4">
            Politique de confidentialité
          </h1>
          <p className="text-[#64748B] mt-2 text-sm">
            Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" })}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-[#E2E8F0] p-8">

          <p className="text-[#475569] leading-relaxed mb-10">
            La présente politique de confidentialité décrit la manière dont <strong>Tabbibak</strong> (accessible
            sur <strong>tabbibak.com</strong> et via l'application mobile Tabbibak) collecte, utilise et protège vos
            données à caractère personnel. Elle s'applique aux patients, aux médecins et aux établissements de
            santé qui utilisent le service. En utilisant Tabbibak, vous reconnaissez avoir pris connaissance de la
            présente politique.
          </p>

          <Section title="1. Responsable du traitement">
            <p>
              Le responsable du traitement des données est l'éditeur de Tabbibak. Pour toute question relative à vos
              données personnelles, vous pouvez nous contacter à l'adresse&nbsp;:
              <strong> contact@tabbibak.com</strong>. Les informations légales complètes figurent dans nos{" "}
              <Link to="/mentions-legales" className="text-[#0596DE] hover:underline">Mentions légales</Link>.
            </p>
          </Section>

          <Section title="2. Données que nous collectons">
            <p>Nous collectons uniquement les données nécessaires au fonctionnement du service&nbsp;:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li><strong>Données de compte&nbsp;:</strong> nom, prénom, adresse e-mail, numéro de téléphone, mot de passe (stocké de manière chiffrée).</li>
              <li><strong>Données de rendez-vous&nbsp;:</strong> médecin ou établissement choisi, date, heure et motif du rendez-vous, statut (en attente, confirmé, annulé).</li>
              <li><strong>Données de santé (le cas échéant)&nbsp;:</strong> dans le cadre du dossier médical hospitalier (module établissements), des informations médicales peuvent être enregistrées par le personnel soignant autorisé (consultations, ordonnances, examens). Ces données sont confidentielles et soumises au secret médical.</li>
              <li><strong>Données techniques&nbsp;:</strong> données de connexion et de sécurité (jetons d'authentification), informations strictement nécessaires au bon fonctionnement et à la sécurité du service.</li>
            </ul>
            <p className="mt-2">Nous ne collectons pas votre localisation précise et n'accédons pas à vos contacts, photos ou fichiers en dehors de ce que vous transmettez volontairement.</p>
          </Section>

          <Section title="3. Finalités d'utilisation">
            <p>Vos données sont utilisées pour&nbsp;:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>créer et gérer votre compte&nbsp;;</li>
              <li>permettre la prise, le déplacement et l'annulation de rendez-vous&nbsp;;</li>
              <li>vous envoyer des notifications relatives à vos rendez-vous (confirmation, déplacement, annulation)&nbsp;;</li>
              <li>permettre aux établissements de santé de gérer leur activité (pour le module hospitalier)&nbsp;;</li>
              <li>assurer la sécurité du service et prévenir les abus.</li>
            </ul>
          </Section>

          <Section title="4. Base légale et consentement">
            <p>
              Le traitement de vos données repose sur l'exécution du service que vous demandez (prise de rendez-vous,
              gestion de compte), sur votre consentement, et sur nos obligations légales. Vous pouvez retirer votre
              consentement à tout moment en supprimant votre compte ou en nous contactant.
            </p>
          </Section>

          <Section title="5. Partage des données">
            <p>Vos données ne sont jamais vendues. Elles peuvent être partagées uniquement avec&nbsp;:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li><strong>le médecin ou l'établissement</strong> auprès duquel vous prenez rendez-vous, dans la stricte mesure nécessaire à la prise en charge&nbsp;;</li>
              <li><strong>nos prestataires techniques</strong> qui hébergent et font fonctionner le service (hébergement applicatif et base de données, envoi d'e-mails), tenus à la confidentialité&nbsp;;</li>
              <li><strong>le prestataire de paiement</strong>, le cas échéant, pour les abonnements professionnels (les données bancaires ne transitent pas par nos serveurs).</li>
            </ul>
            <p className="mt-2">Nous pouvons également divulguer des données si la loi l'exige.</p>
          </Section>

          <Section title="6. Hébergement et sécurité">
            <p>
              Les données sont hébergées sur des infrastructures sécurisées. Nous mettons en œuvre des mesures
              techniques et organisationnelles pour les protéger&nbsp;: chiffrement des mots de passe, connexions
              sécurisées (HTTPS), authentification par jeton, contrôle d'accès par rôle (notamment cloisonnement des
              données médicales par service au sein des établissements). Les données médicales privées sont stockées
              séparément et leur accès est restreint au personnel autorisé.
            </p>
          </Section>

          <Section title="7. Durée de conservation">
            <p>
              Nous conservons vos données aussi longtemps que votre compte est actif et que cela est nécessaire pour
              fournir le service. Vous pouvez demander la suppression de votre compte et de vos données à tout moment.
              Certaines données peuvent être conservées plus longtemps lorsque la loi l'impose (par exemple obligations
              comptables ou de santé).
            </p>
          </Section>

          <Section title="8. Vos droits">
            <p>
              Conformément à la loi algérienne n° 18-07 du 10 juin 2018 relative à la protection des personnes
              physiques dans le traitement des données à caractère personnel, vous disposez des droits suivants&nbsp;:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>droit d'accès à vos données&nbsp;;</li>
              <li>droit de rectification des données inexactes&nbsp;;</li>
              <li>droit à l'effacement (suppression) de votre compte et de vos données&nbsp;;</li>
              <li>droit d'opposition et de limitation du traitement.</li>
            </ul>
            <p className="mt-2">
              Pour exercer ces droits, écrivez-nous à <strong>contact@tabbibak.com</strong>. Nous répondrons dans un
              délai raisonnable.
            </p>
          </Section>

          <Section title="9. Cookies et stockage local">
            <p>
              Tabbibak utilise un stockage local sur votre appareil uniquement à des fins techniques (maintien de
              votre session de connexion). Nous n'utilisons pas de cookies publicitaires ni de pisteurs tiers à des
              fins de marketing.
            </p>
          </Section>

          <Section title="10. Suppression du compte">
            <p>
              Vous pouvez à tout moment demander la suppression de votre compte et des données associées en nous
              contactant à <strong>contact@tabbibak.com</strong>. La suppression entraîne l'effacement de vos données
              personnelles, sous réserve des obligations légales de conservation.
            </p>
          </Section>

          <Section title="11. Mineurs">
            <p>
              Le service n'est pas destiné à être utilisé de manière autonome par des mineurs sans l'accord et la
              supervision d'un parent ou tuteur légal. Les rendez-vous concernant un enfant doivent être gérés par un
              adulte responsable.
            </p>
          </Section>

          <Section title="12. Modifications de la politique">
            <p>
              Nous pouvons mettre à jour la présente politique de confidentialité. Toute modification sera publiée sur
              cette page avec une date de mise à jour actualisée. Nous vous invitons à la consulter régulièrement.
            </p>
          </Section>

          <Section title="13. Contact">
            <p>
              Pour toute question relative à cette politique ou au traitement de vos données&nbsp;:
              <br />
              <strong>E-mail&nbsp;: contact@tabbibak.com</strong>
            </p>
          </Section>

          <p className="text-[#94A3B8] text-sm mt-8 pt-6 border-t border-[#E2E8F0]">
            Ce document constitue la politique de confidentialité de Tabbibak. Pour une mise en conformité juridique
            complète adaptée à votre situation, il est recommandé de la faire relire par un conseil juridique.
          </p>

        </div>
      </div>
    </div>
  );
}
